import { ADMIN_ROLES } from '../utils/roleHelpers';
/* ── Timesheet Sidebar Nav Items ── */
export const NAV_TIMESHEET = {
  label: 'Timesheets',
  icon: 'pending_actions',
  path: '/timesheets',
  roles: ['employee'] as string[],
} as const;

export const NAV_ADMIN_TIMESHEET = {
  label: 'Timesheet Reports',
  icon: 'pending_actions',
  path: '/management/timesheets',
  roles: ADMIN_ROLES,
} as const;

export const NAV_TIMESHEET_APPROVALS = {
  label: 'Timesheet Approvals',
  icon: 'fact_check',
  path: '/timesheets/approvals',
  groupOwnerOrRoles: ADMIN_ROLES,
} as const;

/* ── Timesheet Management ── */

export const TIMESHEET_STRINGS = {
  PAGE_TITLE: 'My Timesheets',
  BANNER_TITLE: 'Timesheet Management',
  BANNER_SUBTITLE: 'Log and track your daily work hours',
  VIEW_MY_TIMESHEETS: 'My Timesheet',
  VIEW_TEAM_HISTORY: 'Team History',
  BTN_ADD_TASK: 'Add Task',
  BTN_SUBMIT_TIMESHEET: 'Submit WorkLog',
  BTN_RESUBMIT_TIMESHEET: 'Resubmit WorkLog',
  BTN_UPDATE_TIMESHEET: 'Update WorkLog',
  BTN_APPROVE: 'Approve',
  BTN_REJECT: 'Reject',
  BTN_EXPORT: 'Export',
  BTN_RESET: 'Reset',
  TXT_VERIFIED: 'Verified',
  TXT_REVIEW_AND_ACTION: 'Review and Action',
  STAT_HOURS_THIS_MONTH: 'Hours This Month',
  STAT_HOURS_THIS_WEEK: 'Hours This Week',
  STAT_PENDING_APPROVAL: 'Pending Approval',
  STAT_NEEDS_ATTENTION: 'Needs Attention',
  BTN_ADD_TIMESHEET: 'Add WorkLog',
  BTN_APPLY_LEAVE: 'Apply Leave',
  PLACEHOLDER_SEARCH: 'Search by employee...',
  PLACEHOLDER_STATUS: 'All Statuses',
  OPT_PENDING: 'Pending',
  OPT_APPROVED: 'Approved',
  OPT_REJECTED: 'Rejected',
  OPT_SUBMITTED: 'Pending',
  LBL_DATE: 'Date',
  LBL_TASK: 'Work Description',
  LBL_HOURS: 'Time Log in',
  LBL_PROJECT: 'Work / Project',
  LBL_PROJECT_NAME: 'Project Name',
  LBL_TOTAL_HOURS: 'Total Hours',
  COL_EMPLOYEE: 'Employee',
  COL_DATE: 'Date',
  COL_TOTAL_HOURS: 'Total Hours',
  COL_STATUS: 'Status',
  COL_ACTIONS: 'Actions',
  ACTION_VIEW: 'View',
  ACTION_EDIT: 'Edit',
  ACTION_DELETE: 'Delete',
  ERR_MISSING_FIELDS: (fields: string) => `Missing required field(s): ${fields}.`,
  ERR_MAX_HOURS: 'Total hours cannot exceed 24 hours per day',
  ERR_MIN_HOURS: 'Total hours must be greater than 0',
  ERR_EIGHT_HOURS: 'Total hours must be at least 8 hours',
  ERR_LEAVE_DAY: 'Cannot log time on an applied leave day',
  ERR_ALREADY_APPLIED: 'WorkLog for this date is already applied',
  ERR_DATE_FUTURE: 'Cannot add tasks for future dates',
  ERR_DATE_PAST: 'Cannot log time for dates older than 5 business days',
  ERR_WEEKEND_LOG: 'Cannot log time for Saturdays and Sundays',
  EMPTY_STATE: 'No tasks logged for this date. Click Add Task to get started.',
} as const;

export const TIMESHEET_APPROVALS_STRINGS = {
  PAGE_TITLE: 'Timesheet Approvals',
  BANNER_TITLE: 'Timesheet Approvals',
  BANNER_SUBTITLE: 'Review and approve team timesheets',
  TEAM_TIMESHEETS: 'Team Timesheets',
  TEAM_TIMESHEETS_SUB: 'Review pending timesheet submissions from your team members',
  COL_EMPLOYEE: 'Employee',
  COL_DATE: 'Date',
  COL_HOURS: 'Total Hours',
  COL_STATUS: 'Status',
  COL_ACTIONS: 'Actions',
  EMPTY_STATE_PREFIX: 'No ',
  EMPTY_STATE_SUFFIX: ' timesheets found at this time.',
  BTN_RETRY: 'Retry',
  MODAL_APPROVE_TITLE: 'Approve WorkLog',
  MODAL_REJECT_TITLE: 'Reject WorkLog',
  MODAL_APPROVE_DESC: 'Are you sure you want to approve this worklog?',
  MODAL_REJECT_PLACEHOLDER: 'Please provide a reason for rejecting this workLog',
  TAB_PENDING: 'PENDING',
  TAB_APPROVED: 'APPROVED',
  TAB_REJECTED: 'REJECTED',
};

export const TIMESHEET_TAB_KEYS = {
  MY_TIMESHEETS: 'my_timesheets',
  TEAM_TIMESHEETS: 'team_timesheets',
  ALL_TIMESHEETS: 'all_timesheets',
} as const;

export const TIMESHEET_TAB_LABELS: Record<string, string> = {
  [TIMESHEET_TAB_KEYS.MY_TIMESHEETS]: 'My Timesheet',
  [TIMESHEET_TAB_KEYS.TEAM_TIMESHEETS]: 'Team Timesheets',
  [TIMESHEET_TAB_KEYS.ALL_TIMESHEETS]: 'All Timesheets',
};

export const TIMESHEET_PROJECT_OPTIONS = [
  { label: 'Project', value: 'Project' },
  { label: 'Poc', value: 'Poc' },
  { label: 'Learning', value: 'Learning' },
  { label: 'Leave', value: 'Leave' },
];

export const TIMESHEET_ADMIN_STRINGS = {
  PAGE_TITLE: 'Admin Timesheet Listing',
  BANNER_TITLE: 'All Timesheets',
  BANNER_SUBTITLE: 'View and manage all employee timesheets across the organization',
  LBL_EMPLOYEE: 'Employee',
  LBL_MONTH: 'Month',
  LBL_STATUS: 'Status',
  LBL_DATE: 'Date',
  PLACEHOLDER_EMPLOYEE: 'Select Employee',
  PLACEHOLDER_STATUS: 'All Status',
  PLACEHOLDER_MONTH: 'Select Month',
  COL_EMPLOYEE: 'Employee',
  COL_DATE: 'Date',
  COL_HOURS: 'Total Hours',
  COL_STATUS: 'Status',
  COL_ACTIONS: 'Actions',
  EMPTY_STATE: 'No timesheets found matching the filters.',
  ACTION_VIEW: 'View',
  BTN_CLEAR_FILTERS: 'Clear Filters',
  BTN_EXPORT: 'Export'
} as const;
